module.exports = __webpack_public_path__ + "img/rocket.a6ddf73e.svg";